import React, { useEffect, useState } from 'react';
import { FilterOptionKeys } from '@mybestbrands/types';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { safelyParseJSON } from '@/app/helpers/searchparams';
import { useTranslation } from 'next-i18next';
import styles from './styles.module.scss';
import { trackSSTEvent } from '@/app/utils/tracking';

const SaleFilter = () => {
  const { t } = useTranslation('filters');
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();

  const params = new URLSearchParams(searchParams ?? '');
  const filters = params.get('filters');
  const filtersParsed = safelyParseJSON(filters);
  const [isActive, setIsActive] = useState(filtersParsed ? !!filtersParsed[FilterOptionKeys.SALE] : false);

  useEffect(() => {
    const filters = params.get('filters');
    const filtersParsed = safelyParseJSON(filters);
    setIsActive(filtersParsed ? !!filtersParsed[FilterOptionKeys.SALE] : false);
  }, [searchParams]);

  async function toggleSaleFilter() {
    const page = params.get('page');
    params.set('filters', JSON.stringify({ ...filtersParsed, [FilterOptionKeys.SALE]: !isActive }));

    if (page) params.delete('page');

    const url = `${pathname}?${params.toString()}`;
    router.push(url);

    trackSSTEvent('top_filter_select', {
      filter_name: 'sale',
      selected_count: !isActive ? 1 : 0,
    });
  }

  return (
    <div className={`${styles['filter']} ${isActive ? styles['active'] : ''}`} onClick={toggleSaleFilter}>
      {t('sale')}
    </div>
  );
};

export default SaleFilter;
